import PropTypes from 'prop-types';
import Card from 'components/Card';

/** Card suelto del CMS legacy. */
const CardBlock = ({ value }) => (
  <section className='cms-block cms-block--card py-6 md:py-6 lg:py-8'>
    <div className='w-full md:max-w-2xl lg:max-w-3xl mx-auto px-6'>
      <Card {...value} />
    </div>
  </section>
);

CardBlock.propTypes = {
  value: PropTypes.object.isRequired,
};

export default CardBlock;
